import React, { useRef } from 'react';
import './Contact.scss';
import { FiPhoneCall, FiMail } from 'react-icons/fi';
import emailjs from '@emailjs/browser';
import Navbar from "../Navbar/Navbar";
import Fotter from "../Fotter/Fotter";

const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm(
            'service_zmyb12x',    // Replace with your actual service ID
            'template_q56kjga',   // Replace with your actual template ID
            form.current,
            'q5m4tH2ioaAKbzoMQ'   // Replace with your actual public key (previously called user ID)
        ).then((result) => {
            alert("Message sent successfully!");
            form.current.reset();
        }, (error) => {
            alert("Failed to send message: " + error.text);
        });
    };

    return (
        <>
            <section className="contact-section">
                <Navbar />
                <div className='contact-section-child'>
                    <h1 className="contact-title">CONTACT</h1>
                    <div className="contact-container">
                        <form ref={form} onSubmit={sendEmail} className="contact-form">
                            <h2>Get in touch</h2>
                            <p>Your full name</p>
                            <input type="text" name="name" placeholder="Your full name" required />
                            <p>Email address</p>
                            <input type="email" name="email" placeholder="Email address" required />
                            <p>Message</p>
                            <textarea name="message" placeholder="Message" rows="6" required></textarea>
                            <button type="submit">Send</button>
                        </form>

                        <div className="contact-info">
                            <div className="info-item">
                                <FiPhoneCall  size={35} className="icon"/>
                                <div>
                                    {/*<h3>Phone Number</h3>*/}
                                    <p>+374 77 513 344</p>
                                </div>
                            </div>
                            <div className="info-item">
                                <FiMail size={35} className="icon" />
                                <div>
                                    {/*<h3>Email Address</h3>*/}
                                    <p>info@airworker.aero</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Fotter />
        </>
    );
};

export default Contact;